/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    ImagesCarouselItem = require('./imagesCarouselItem'),
    Images = require('../collections/images'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.CollectionView.extend({
    attributes: {
        name: 'imagesCarousel',
        class: 'imagesCarousel'
    },
    events: {
        'click a': 'onPreviousNext'
    },
    childView: ImagesCarouselItem,
    childViewContainer: 'div[name=carouselImages]',
    imageIndex: 0,
    tagName: 'div',
    template: templates.imagesCarousel,
    initialize: function () {
        this.collection = this.options.images;
    },
    childViewOptions: function (model) {
        return {
            index: this.collection.indexOf(model),
            count: this.collection.length
        };
    },
    onPreviousNext: function (event) {
        const images = this.$el.find('div[name=carouselImages] > div');
        switch (event.currentTarget.dataset.slide) {
            case 'prev':
                if (this.imageIndex > 0) {
                    this.imageIndex--;
                } else {
                    this.imageIndex = this.collection.length - 1;
                }
                break;
            case 'next':
                if (this.imageIndex < this.collection.length - 1) {
                    this.imageIndex++;
                } else {
                    this.imageIndex = 0;
                }
                break;
            default:
                break;
        }
        images.removeClass('active');
        jQuery(images[this.imageIndex]).addClass('active');
        return false;
    },
    templateContext: function () {
        return {
            empty: this.collection.length ? false : true,
            emptyMessage: 'noImagesLabel'
        };
    }
});
